import { useTranslations } from '@vocab/react';
import { Box, Heading, List, IconTick, Text, Stack } from 'braid-design-system';
import type React from 'react';

import type { AdBudgetInfo } from '../../context/reducer';

import translations from './.vocab';

interface SellingPointsProps {
  readonly adBudgetInfo: AdBudgetInfo;
}
const SellingPoints: React.FC<React.PropsWithChildren<SellingPointsProps>> = ({
  adBudgetInfo,
}: SellingPointsProps) => {
  const { t } = useTranslations(translations);

  return (
    <Box padding="large" background="formAccentSoft" borderRadius="xlarge">
      <Stack space="large">
        <Heading level="3">{t('your ad budget')}</Heading>
        <List type="icon" icon={<IconTick tone="info" />} space="medium">
          {adBudgetInfo.ads !== 'PREMIUM_ONLY' && (
            <>
              <Text>{t('use your ad budget balance to post...')}</Text>
              <Text> {t('your budget will activate after purchase...')}</Text>
            </>
          )}
          {adBudgetInfo.ads === 'PREMIUM_ONLY' ? (
            <>
              <Text>
                {t(
                  'discount applies only when the Premium Ad Budget is still active',
                )}
              </Text>
              <Text>
                {t('your budget will activate after purchase premium...')}
              </Text>
              <Text>{t('use your ad budget balance to post premium...')}</Text>
            </>
          ) : (
            <Text>{t('discount applies for your contract term...')}</Text>
          )}
          {adBudgetInfo.ads === 'BRANDED_ONWARDS' && (
            <Text>{t('all of your ads will include branded features')}</Text>
          )}
        </List>
      </Stack>
    </Box>
  );
};

export default SellingPoints;
